// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Belt_List from "rescript/lib/es6/belt_List.js";
import * as FireLater$LiteracyplanetClientSxActivity from "./FireLater.res.mjs";
import * as FlipperMutationApiTypes$LiteracyplanetClientSxActivity from "./FlipperMutationApiTypes.res.mjs";

function useTryBack(onBack) {
  var match = React.useState(function () {
        return 0;
      });
  var setTryBack = match[1];
  var tryBack = match[0];
  var onTryBack = function (param) {
    setTryBack(function (param) {
          return 1;
        });
  };
  React.useEffect((function () {
          if (tryBack <= 0) {
            return ;
          }
          if (FlipperMutationApiTypes$LiteracyplanetClientSxActivity.isAnythingInTransit()) {
            var timeoutId = setTimeout((function () {
                    console.log("still waiting for questions");
                    setTryBack(function (i) {
                          return i + 1 | 0;
                        });
                  }), 100);
            return (function () {
                      clearTimeout(timeoutId);
                    });
          }
          onBack();
        }), [tryBack]);
  return onTryBack;
}

var Later = FireLater$LiteracyplanetClientSxActivity.Make({});

function useMutationApi(contentMd5, insertAttempt, insertedAttemptId, existingAttemptId, updateActivityCompleted, insertResponse, insertedResponseId, isMarkCompleteDone) {
  var match = React.useState(function () {
        return /* [] */0;
      });
  var setEvents = match[1];
  var events = match[0];
  var fire = Later.use();
  var pushAsyncActivityEvent = function ($$event) {
    fire({
          TAG: "FireSoonish",
          _0: (function () {
              setEvents(function (e) {
                    return Belt_List.concat(e, {
                                hd: $$event,
                                tl: /* [] */0
                              });
                  });
            })
        });
  };
  React.useEffect((function () {
          if (existingAttemptId !== undefined) {
            FlipperMutationApiTypes$LiteracyplanetClientSxActivity.stateMachine.contents = {
              TAG: "AttemptFound",
              _0: existingAttemptId
            };
          } else {
            FlipperMutationApiTypes$LiteracyplanetClientSxActivity.stateMachine.contents = "ProvisioningNewAttempt";
            insertAttempt();
          }
        }), [existingAttemptId]);
  React.useEffect((function () {
          if (insertedAttemptId !== undefined) {
            FlipperMutationApiTypes$LiteracyplanetClientSxActivity.stateMachine.contents = {
              TAG: "AttemptFound",
              _0: insertedAttemptId
            };
          }
          
        }), [insertedAttemptId]);
  React.useEffect((function () {
          var processNext = function (studentActivityAttemptId, prevResponseId) {
            if (!events) {
              FlipperMutationApiTypes$LiteracyplanetClientSxActivity.stateMachine.contents = {
                TAG: "QuestionWaiting",
                _0: studentActivityAttemptId,
                _1: prevResponseId
              };
              return ;
            }
            var match = events.hd;
            if (typeof match !== "object") {
              var tail = events.tl;
              FlipperMutationApiTypes$LiteracyplanetClientSxActivity.stateMachine.contents = "MarkingComplete";
              updateActivityCompleted(studentActivityAttemptId);
              return setEvents(function (param) {
                          return tail;
                        });
            }
            var tail$1 = events.tl;
            var match$1 = match._0;
            FlipperMutationApiTypes$LiteracyplanetClientSxActivity.stateMachine.contents = {
              TAG: "QuestionPersisting",
              _0: studentActivityAttemptId,
              _1: prevResponseId
            };
            insertResponse(studentActivityAttemptId, match$1[2], match$1[3] ? 1 : 0, match$1[0], match$1[1], contentMd5);
            setEvents(function (param) {
                  return tail$1;
                });
          };
          var studentActivityAttemptId = FlipperMutationApiTypes$LiteracyplanetClientSxActivity.stateMachine.contents;
          if (typeof studentActivityAttemptId !== "object") {
            if (studentActivityAttemptId === "MarkingComplete") {
              if (isMarkCompleteDone) {
                FlipperMutationApiTypes$LiteracyplanetClientSxActivity.stateMachine.contents = "Finished";
              }
              
            }
            
          } else {
            switch (studentActivityAttemptId.TAG) {
              case "AttemptFound" :
                  processNext(studentActivityAttemptId._0, "initial");
                  break;
              case "QuestionPersisting" :
                  if (insertedResponseId !== undefined && insertedResponseId !== studentActivityAttemptId._1) {
                    processNext(studentActivityAttemptId._0, insertedResponseId);
                  }
                  break;
              case "QuestionWaiting" :
                  processNext(studentActivityAttemptId._0, studentActivityAttemptId._1);
                  break;
              
            }
          }
        }), [
        events,
        insertedAttemptId,
        insertedResponseId,
        isMarkCompleteDone
      ]);
  React.useEffect((function () {
          return (function () {
                    FlipperMutationApiTypes$LiteracyplanetClientSxActivity.stateMachine.contents = "Initial";
                  });
        }), []);
  var onQuestionFailed = function (question, state, answer) {
    pushAsyncActivityEvent({
          TAG: "QuestionAnswered",
          _0: [
            question,
            state,
            answer,
            false
          ]
        });
  };
  var onQuestionPassed = function (question, state, answer) {
    pushAsyncActivityEvent({
          TAG: "QuestionAnswered",
          _0: [
            question,
            state,
            answer,
            true
          ]
        });
  };
  var onActivityCompleted = function () {
    pushAsyncActivityEvent("ActivityCompleted");
  };
  return [
          onQuestionPassed,
          onQuestionFailed,
          onActivityCompleted
        ];
}

export {
  useTryBack ,
  Later ,
  useMutationApi ,
}
/* Later Not a pure module */
